import React from "react";
import { useSelector } from "react-redux";

import { NewStepper } from "@/components/molecules/NewStepper";
import { NewStepperVE } from "@/components/molecules/NewStepperVE/index";
import { ModalLoading } from "@/components/molecules/ModalLoading";
import { useEmbedded } from "@/hooks/useEmbedded";
import { NewHeader } from "../NewHeader";
import GlobalModalError from "@/features/Comprar/vida-devolucion/shared/components/GlobalModalError";
import { CYBER_CONTENT_BANNER } from "@/features/Comprar/vida-devolucion/step-initial/models/model";
import { BannerBenefits } from "../BannerBenefits";
import { VE_ROUTES_ENDORSEMENT } from "@/utils/consts";
import { BannerCampaign } from "@/components/organisms/BannerCampaign";

const PRODUCTS = {
  vcd: {
    name: "Seguro de Vida Ahorro con Devolución",
    universityName: "Seguro Universitario",
    routes: [
      "/comprar/seguro-vida-devolucion-garantizada/cotizacion",
      "/comprar/seguro-vida-devolucion-garantizada/direccion",
      "/comprar/seguro-vida-devolucion-garantizada/pago",
    ],
    mainRoute: "/comprar/seguro-vida-devolucion-garantizada",
    showHeaderInMainRoute: true,
  },
  vidaPlus: {
    name: "Vida Plus",
    routes: [
      "/comprar/seguro-vida-plus/cotizacion",
      "/comprar/seguro-vida-plus/pago",
    ],
    mainRoute: "/comprar/seguro-vida-plus",
    showHeaderInMainRoute: false,
  },
  vidaEndosable: {
    name: "Vida Endosable 100% Digital",
    routes: VE_ROUTES_ENDORSEMENT.map((route) => route.path),
    mainRoute: "/comprar/seguro-vida-endoso-con-devolucion",
    showHeaderInMainRoute: false,
    useNewHero: true,
    routesInfo: VE_ROUTES_ENDORSEMENT,
  },
};

const getActiveProduct = (pathname) => {
  return Object.values(PRODUCTS).find(
    (product) =>
      product.routes.includes(pathname) ||
      ((product.showHeaderInMainRoute || product.useNewHero) &&
        pathname === product.mainRoute),
  );
};

export const NewLayout = ({ children }) => {
  const { pathname } = window.location;
  const { isEmbedded } = useEmbedded();

  const activeProduct = getActiveProduct(pathname);
  const showHeader = !!activeProduct;
  const isVcdStepInitial = pathname === PRODUCTS.vcd.mainRoute;
  const isVeStepInitial = pathname === PRODUCTS.vidaEndosable.mainRoute;
  const isEndorsementRoute = VE_ROUTES_ENDORSEMENT.some((route) =>
    pathname.includes(route.path),
  );

  const { experimentCyber } = useSelector((state) => state.experiment);
  const {
    isActive: isCyberActive,
    startDate: cyberStartDate,
    endDate: cyberEndDate,
  } = experimentCyber;

  const renderHeader = () => {
    if (isEmbedded || !showHeader || isVeStepInitial) return null;

    return (
      <NewHeader
        product={activeProduct.name}
        productUniversity={activeProduct.universityName}
      />
    );
  };

  return activeProduct ? (
    <>
      <GlobalModalError />
      {isVcdStepInitial && (
        <>
          {isCyberActive && (
            <BannerCampaign
              dynamicContent={CYBER_CONTENT_BANNER.map((item) => ({
                ...item,
                venta_digital_cintillo: {
                  ...item.venta_digital_cintillo,
                  time: {
                    ...item.venta_digital_cintillo.time,
                    start_date: cyberStartDate,
                    final_date: cyberEndDate,
                  },
                },
              }))}
              valueEntry={
                CYBER_CONTENT_BANNER[0].venta_digital_cintillo.name_product
              }
            />
          )}
          <BannerBenefits />
        </>
      )}
      {renderHeader()}
      {activeProduct.routes.includes(pathname) ? (
        isEndorsementRoute ? (
          <NewStepperVE
            routeMain={activeProduct?.mainRoute}
            routes={activeProduct?.routesInfo}
          />
        ) : (
          <NewStepper
            currentStep={activeProduct.routes.indexOf(pathname) + 1}
            itemsStepsRoutes={activeProduct.routes}
            routeMain={activeProduct.mainRoute}
          />
        )
      ) : null}
      {children}
      <ModalLoading />
    </>
  ) : (
    <>{children}</>
  );
};
